export const ADMIN_TYPE = "admin";
export const SCREENER_TYPE = "screener";
export const READER_TYPE = "reader";

export const ROLE_TYPES = [ADMIN_TYPE, SCREENER_TYPE, READER_TYPE] as const;
export type RoleType = (typeof ROLE_TYPES)[number];

export const isKnownRoleType = (type: string): type is RoleType => {
    return ROLE_TYPES.includes(type as RoleType);
};

// Whether a role is allowed to spend a bus from a bus-limited subscription.
// This mirrors the `unlock_bus` Postgres function in `nira-hasura`, which only
// inserts an `unlocked_buses` row for an admin or a screener: a reader can view
// buses their team has already unlocked, but can never spend one. Note the
// function checks the role *only* on bus-limited subscriptions -- on an
// unlimited subscription nothing is spent, so every role can unlock.
export const canUnlockBuses = (role: RoleType): boolean => {
    return role === ADMIN_TYPE || role === SCREENER_TYPE;
};

export const convertToRoleType = (string: string): RoleType => {
    if (isKnownRoleType(string)) {
        return string;
    }

    throw new Error("Unexpected role type");
};
